class AppCustomOrder extends HTMLElement {
  constructor() {
    super();

    this.products = this.querySelectorAll('.product-preview-component button');
    this.allSteps = this.querySelectorAll('.custom-order-item');
    this.stepOne = this.querySelectorAll('.custom-order-item.step-1');
    this.stepTwo = this.querySelector('.custom-order-item.step-2');
    this.btnMove = this.querySelectorAll('.button-move');
    this.btnProductListing = this.querySelectorAll('.button-product-listing');
    this.btnCustomSizeModal = this.querySelectorAll('.custom-size-modal');
    this.modalContainer = this.querySelector('modal-custom-size');
    this.cancelBtnModal = this.modalContainer.querySelector('.close-modal');
    this.borderLine = this.querySelectorAll('.border-line');
    this.activeBorderLine = 1;
    this.swiperActiveIndex = 0;
    this.textBlue = this.querySelectorAll('.text-color-blue');
    this.windowWith = window.outerWidth;
    this.sendDraftOrder = this.querySelector('.send-draft-order');
    this.formDraftorder = this.querySelector('.form-send-draft-order');
    this.inputs = this.querySelectorAll('.form-group input');
    this.message = this.querySelector('#message');

    this.titlesDropdown = {
      qty: 'Quantity',
      printing: 'Printing',
      material: 'Material',
      size: 'Size',
      production: 'Production',
      'print-colors': 'Print Colors',
      shape: 'Shape',
      'sub-material': 'Sub Material',
    };

    this.dropDownType = {
      qty: 'quantity-dropdown',
      material: 'custom-dropdown',
      printing: 'custom-dropdown',
      size: 'size-dropdown',
      production: 'custom-dropdown',
      'print-colors': 'custom-dropdown',
      shape: 'custom-dropdown',
      'sub-material': 'custom-dropdown',
    };

    if (this.inputs.length > 0) {
      this.inputs.forEach((input) => {
        input.addEventListener('input', (e) => {
          let val = this.validationInputs(e.target, e.target.name);
          if (!val) {
            e.target.classList.add('ng-invalid');
            e.target.classList.remove('ng-untouched');
          } else {
            e.target.classList.remove('ng-invalid');
            e.target.classList.add('ng-untouched');
          }
          this.showHidden();
        });
      });
    }

    if (this.sendDraftOrder) {
      this.sendDraftOrder.addEventListener('click', (e) => {
        e.preventDefault();

        let variantionsAlt = this.querySelector('variant-selects');

        if (!this.formDraftorder.reportValidity() && !variantionsAlt.json.disabled) {
          this.formDraftorder.reportValidity();
        } else {
          this.sendProductAlt(variantionsAlt.values, variantionsAlt);
        }
      });
    }

    const options = {
      spaceBetween: 1,
      autoHeight: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
      navigation: {
        nextEl: '.swiper-navigation-next-alt',
        prevEl: '.swiper-navigation-prev-alt',
      },
      pagination: {
        el: '.swiper-component-pagination',
        clickable: true,
        bulletClass: 'swiper-component-pagination-item',
        bulletActiveClass: 'swiper-component-pagination-item-active',
        renderBullet: (index, className) => {
          return `<div class="${className}"></div>`;
        },
      },
    };

    let swiper = new Swiper('.swiper-container', options);
    this.swiper = swiper;

    this.swiper[1].on('slideChange', (swiperRef) => {
      this.swiperActiveIndex = swiperRef.realIndex;
    });

    this.swiper[0].on('slideChange', (swiperRef) => {
      this.swiperActiveIndex = swiperRef.realIndex;
    });

    this.buttonNext = this.querySelectorAll('.swiper-navigation-next-alt');
    this.buttonPrev = this.querySelectorAll('.swiper-navigation-prev-alt');

    if (this.buttonNext.length > 0) {
      this.buttonNext.forEach((buttonNext, index) => {
        buttonNext.addEventListener('click', (e) => {
          let count = e.target.closest('div.custom-order-item').querySelectorAll('.product-preview-container').length;
          let end = this.isFullScreen() + this.swiperActiveIndex;
          if (end <= count) {
            e.target.closest('div.custom-order-item').querySelector('.text-color-blue').innerHTML = `${
              this.swiperActiveIndex + 1
            }-${end}`;
          } else {
            e.target.closest('div.custom-order-item').querySelector('.text-color-blue').innerHTML = `${
              count - this.isFullScreen()
            }-${count}`;
          }
        });
      });
    }

    if (this.buttonPrev.length > 0) {
      this.buttonPrev.forEach((buttonNext, index) => {
        buttonNext.addEventListener('click', (e) => {
          e.target.closest('div.custom-order-item').querySelector('.text-color-blue').innerHTML = `${
            this.swiperActiveIndex + 1
          }-${this.isFullScreen() + this.swiperActiveIndex}`;
        });
      });
    }

    window.addEventListener(
      'resize',
      () => {
        this.windowWith = window.outerWidth;
      },
      true,
    );
  }

  sendProductAlt(json, element) {
    let formData = new FormData(this.formDraftorder);
    this.message.classList.add('hidden');

    let body = {
      email: formData.get('email'),
      name: formData.get('name'),
      phone: formData.get('phone'),
      note: element.properties['_designInstruction'] || '',
      lineItems: [
        {
          variantId: 'gid://shopify/ProductVariant/' + element.currentVariant.id,
          quantity: parseInt(json['qty']),
          customAttributes: [],
        },
      ],
    };

    for (let key in element.properties) {
      if (element.properties.hasOwnProperty(key)) {
        body['lineItems'][0]['customAttributes'].push({
          key: key,
          value: `${element.properties[key]}`,
        });
      }
    }

    if (element.idUser != '') {
      body['customerId'] = `gid://shopify/Customer/${element.idUser}`;
    }

    this.querySelectorAll('.custom-order-item').forEach((item) => {
      item.classList.add('send-form');
    });

    body = JSON.stringify(body);

    console.log(body)

    fetch(`${window.internalApi.baseUrl}/orders/draft-create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body,
    })
      .then((response) => response.json())
      .then((response) => {
        if ('error' in response) {
          this.querySelectorAll('.custom-order-item').forEach((item) => {
            item.classList.remove('send-form');
          });
          this.message.innerHTML = `<span>${response.message}</span>`;
          this.message.classList.remove('hidden');
        } else {
          this.querySelectorAll('.custom-order-item').forEach((item) => {
            item.classList.add('hidden');
            item.classList.remove('send-form');
          });

          this.querySelector('.custom-quote-step-for-container').classList.remove('hidden');
          this.formDraftorder.reset();
        }
      })
      .catch((err) => {
        this.querySelectorAll('.custom-order-item').forEach((item) => {
          item.classList.remove('send-form');
        });

        this.message.innerHTML = `<span>${err.message}</span>`;
        this.message.classList.remove('hidden');
      });
  }

  showHidden() {
    let ngValid = this.querySelector('input.ng-invalid');
    let productAlt = this.querySelector('variant-selects-alt-custom');
    if (productAlt) {
      if (ngValid || productAlt.json.disabled) {
        this.sendDraftOrder.classList.add('button-disable');
      } else {
        this.sendDraftOrder.classList.remove('button-disable');
      }
    } else {
      if (ngValid) {
        this.sendDraftOrder.classList.add('button-disable');
      } else {
        this.sendDraftOrder.classList.remove('button-disable');
      }
    }
  }

  validationInputs(input, name) {
    let validation = true;
    switch (name) {
      case 'email':
        if (!this.emailValidation(input.value)) {
          validation = false;
        }
        break;

      default:
        if (input.value == '') {
          validation = false;
        }
        break;
    }
    return validation;
  }

  emailValidation(val) {
    let regexp =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexp.test(val);
  }

  isFullScreen() {
    if (this.windowWith >= 1440) {
      return 3;
    } else if (this.windowWith >= 768) {
      return 2;
    } else if (this.windowWith >= 992) {
      return 3;
    }
  }

  setBorderLine() {
    this.borderLine.forEach((border, index) => {
      if (index <= this.activeBorderLine) {
        border.classList.add('active-line');
      } else {
        border.classList.remove('active-line');
      }
    });
  }

  connectedCallback() {
    this.products.forEach((elm) => {
      elm.addEventListener('click', this.eventClickProducts.bind(this));
    });

    this.btnMove.forEach((elm) => {
      elm.addEventListener('click', this.eventClickButtonsMove.bind(this));
    });

    this.btnProductListing.forEach((elm) => {
      elm.addEventListener('click', this.eventClickButtonsProductListing.bind(this));
    });

    this.btnCustomSizeModal.forEach((elm) => {
      elm.addEventListener('click', (e) => {
        e.preventDefault();

        this.modalContainer.open();
      });
    });
  }

  hideAllStep() {
    this.allSteps.forEach((elm) => {
      elm.style.display = 'none';
    });
  }

  hideFirstStep() {
    this.stepOne.forEach((elm) => {
      elm.style.display = 'none';
      elm.classList.remove('active');
    });
  }

  svgDropdownInner() {
    return `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
  </svg>`;
  }

  svgDropdown() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('role', 'presentation');
    svg.classList.add('icon', 'icon-caret');
    svg.setAttribute('viewBox', '0 0 10 6');
    svg.innerHTML = `<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">`;
    return svg;
  }

  creationSelectedText(data) {
    const selectedText = document.createElement('div');
    selectedText.id = `${data.id}-selected-text`;
    selectedText.classList.add('selected-text');

    if ('image_path' in data && data.image_path) {
      selectedText.classList.add('image-item');
      const image = document.createElement('img');
      image.classList.add('image');
      image.src = data.image_path;
      image.loading = 'lazy';

      selectedText.appendChild(image);
    }

    const title = document.createElement('span');

    title.classList.add('title', 'value-dropdown');
    if (data.type == 'material') {
      title.classList.add('text-uppercase');
      title.textContent = data.selected_value;
      selectedText.appendChild(title);
      return selectedText;
    } else if (data.type == 'size') {
      const value = data.selected_value.split('x');
      const size = value.map((val) => `<b>${val}</b>`).join('x');
      title.id = `${data.id}-selected-text`;
      title.classList.add('selected-text');
      title.innerHTML = `${size}`;
      return title;
    } else {
      const b = document.createElement('b');
      title.id = `${data.id}-selected-text`;
      title.classList.add('selected-text');
      b.classList.add('value-dropdown');
      b.textContent = data.selected_value;
      title.appendChild(b);
      return title;
    }
    return selectedText;
  }

  creationInputContent(data) {
    const content = document.createElement('div');
    content.classList.add('content');

    content.setAttribute('role', 'combobox');
    content.setAttribute('aria-haspopup', 'listbox');
    content.setAttribute('aria-labelledby', `${data.id}-labe ${data.id}-selected-text`);
    content.setAttribute('aria-expanded', 'false');

    const selectedText = this.creationSelectedText(data);

    content.appendChild(selectedText);
    content.appendChild(this.svgDropdown());

    return content;
  }

  creationElementWithOnlyClass(element, classes) {
    const tempElement = document.createElement(element);
    tempElement.classList.add(classes);
    return tempElement;
  }

  creationCustomInputViewTop(data) {
    let customInputViewTop = this.creationElementWithOnlyClass('div', 'top');
    let tagHTML = 'div';
    if (data.type == 'material' || ("editable" in data && data.editable )) {
      tagHTML = 'div';
    } else if (data.type == 'size' || data.type == 'quantity') {
      tagHTML = 'span';
    }

    customInputViewTop.innerHTML = `
    <div class="clicked-input ${ "editable" in data && data.editable ? "editable" : "" }">
    ${
      "editable" in data && data.editable ? `<input id="editableInput" type="number" class="input selected-open-text" min="1" value="250">` : `<${tagHTML} class="image-item selected-open-text">
      ${'image_path' in data && data.image_path ? `<img loading="lazy" class="image" src="${data.image_path}">` : ''}
      <span class="title ${'image_path' in data && data.image ? 'text-uppercase' : ''} value-dropdown">${
        data.selected_value
      }</span>
    </${tagHTML}>`
    }
      ${this.svgDropdownInner()}
    </div>`;

    return customInputViewTop;
  }

  creationSelectCustomOptions(data) {
    let string = '';
    if (data.type == 'material' ) {
      console.log("data", data)
      data.options.forEach((option, index) => {
        string += `<div
        class="item large selectCustom-option"
        role="option"
        data-value="${option.value}"
        ${'type_economy' in option ? `data-quality="${option.type_economy}"` : ''}
        id="${data.id}-option-${index}"
        ${index == 0 ? `aria-selected="true"` : ''}
        >
        <div class="image-item">
        ${
          'image_path' in option && option.image_path
            ? `<img loading="lazy" class="image" src="${option.image_path}">`
            : ''
        }
            <div class="title-container">
              <span class="title value value-dropdown">${option.value}</span>
              ${'type_economy' in option ? `<span class="description">${option.type_economy}</span>` : ''}
            </div>
          </div>
        </div>
        `;
      });
    } else if (data.type == 'size' || data.type == 'quantity') {
      data.options.forEach((option, index) => {
        const value = typeof option.value === 'string' ? option.value.split('x') : [option.value];
        const size = value.map((val) => `<b>${val}</b>`).join('x');
        string += `<div
        class="item selectCustom-option"
        role="option"
        data-value="${option.value}"
        id="${data.id}-option-${index}"
        ${index == 0 ? `aria-selected="true"` : ''}
        >
          <span class="value">
            ${size}
            ${
              'label_description' in option && option.label_description
                ? `<div class="size-label-desc">${option.label_description}</div>`
                : ''
            }
          </span>

          <span class="price"></span>
        </div>
        `;
      });
    } else {
      data.options.forEach((option, index) => {
        const value = typeof option.value === 'string' ? option.value.split('x') : [option.value];
        const size = value.map((val) => `<b>${val}</b>`).join('x');
        string += `<div
      class="item selectCustom-option"
      role="option"
      data-value="${option.value}"
      id="${data.id}-option-${index}"
      ${index == 0 ? `aria-selected="true"` : ''}
      >
        <span class="value">
        <b class="value-dropdown">${size}</b>

        </span>
        ${
          'label_description' in option && option.label_description
            ? `<span class="price">${option.label_description}</span>`
            : ''
        }
      </div>
      `;
      });
    }

    return string;
  }

  creationCustomInputSelectCustomOptions(data) {
    const selectCustomOptions = document.createElement('div');
    selectCustomOptions.classList.add('selectCustom-options', 'center', 'padding', 'border-bottom-radius');
    selectCustomOptions.setAttribute('role', 'listbox');
    selectCustomOptions.setAttribute('aria-labelledby', `${data.id}-label`);

    const options = this.creationSelectCustomOptions(data);

    selectCustomOptions.innerHTML = options;
    return selectCustomOptions;
  }

  creationCustomInput(data) {
    const customInput = this.creationElementWithOnlyClass('div', 'custom-input');
    if (data.type != 'material') {
      customInput.classList.add('border');
    }
    // Container for the custom input
    const inputContent = this.creationInputContent(data);
    if (data.type != 'material') {
      customInput.appendChild(inputContent);
    }

    // Container for the custom input
    const customInputView = this.creationElementWithOnlyClass('div', 'view');
    const customInputViewTop = this.creationCustomInputViewTop(data);
    // Set
    customInputView.appendChild(customInputViewTop);
    // Container for the custom input
    const customInputSelectCustomOptions = this.creationCustomInputSelectCustomOptions(data);
    customInputView.appendChild(customInputSelectCustomOptions);
    // Set
    customInput.appendChild(customInputView);

    return customInput;
  }

  creationLabel(data) {
    const label = document.createElement('h6');
    label.classList.add('pre');
    label.id = `${data.id}-label`;
    label.textContent = data.label;
    return label;
  }

  creationSelect(data) {
    let materialDropdown = `<${data.tag} class="custom-dropdown-component ${ data.tag == "material-dropdown" ? "material-color-dropdown" :""}" aria-hidden="true" data-name="${
      data.id
    }" data-quality="${data.type_economy}" data-value="${data.selected_value}" ${
      data.show_unit_price ? 'data-unit-price-by-name="qty"' : ''
    }>`;
    const customDropdownContent = document.createElement('div');
    customDropdownContent.classList.add('custom-dropdown-content');

    const label = this.creationLabel(data);
    customDropdownContent.appendChild(label);

    const customInput = this.creationCustomInput(data);

    customDropdownContent.appendChild(customInput);

    materialDropdown += customDropdownContent.outerHTML;

    materialDropdown += `</${data.tag}>`;

    return materialDropdown;
  }

  eventClickProducts(evt) {
    let json = JSON.parse(evt.target.closest('.select-container').querySelector('script').textContent);
    let scriptTemp = evt.target.closest('.select-container').querySelector('.variants script').textContent;
    let jsonProduct = evt.target.closest('.select-container').querySelector('#product-json').textContent;
    let jsonVariants = evt.target.closest('.select-container').querySelector('#variants-json').textContent;
    const style = evt.target.closest('.image-container').style;
    const url = evt.target.closest('.image-container').dataset.url;
    const title = evt.target.closest('.product-preview-component').querySelector('.title').textContent;
    const description = evt.target.closest('.product-preview-component').querySelector('.description').innerHTML;
    const price = evt.target.closest('.product-preview-component').querySelector('.price').innerHTML;
    const string = document.createElement('div');
    let dropdowns = json.dropdowns;
    const options = json.options_with_values;

    options.forEach((option) => {
      const id = option.name.toLowerCase();
      if(id !== 'title'){
      const optionHandle = this._handlelize(option.name);

      let value = option.values[0];
      if (
        optionHandle == 'material' &&
        json.hasOwnProperty('materials') &&
        json.materials != null &&
        this.dataset.type != 'extension-product'
      ) {
        const tempOptions = option.values.map((tempOption) => {
            const val = json.materials.find((material) => {
              return material.outside.toLowerCase() == tempOption.toLowerCase()
            });
            
          if(!val) return;
          return {
            value: tempOption,
            image_path: val.images.material,
            type_economy: val.type_economy,
          };
        }).filter((val) => val != undefined);
        const firstValues = json.materials.find((material) => material.outside == value);
        const data = {
          id,
          options: tempOptions,
          image_path: firstValues.images.material,
          selected_value: value,
          type_economy: firstValues.type_economy,
          label: 'Material',
          type: 'material',
          tag: 'material-dropdown'
        };
        const materials = this.creationSelect(data);
        string.insertAdjacentHTML('beforeend', materials);
      } else {
        let text = this.titlesDropdown[optionHandle];
        const type = this.dropDownType[optionHandle];
        text = this.titlesDropdown[optionHandle] || option.name;
        const firstLetter = text.charAt(0);
        const rest = text.slice(1);
        const label = firstLetter.toUpperCase() + rest;

        const tempOptions = option.values.map((tempOption) => {
          return {
            value: tempOption,
          };
        });
        const data = {
          id: optionHandle,
          options: tempOptions,
          selected_value: value,
          label: option.name,
          type: 'custom',
          tag: type,
        };
        const materials = this.creationSelect(data);
        string.insertAdjacentHTML('beforeend', materials);
      }
      this.stepTwo.querySelector('.note-column .custom-size-modal').style.display = 'none';
      this.stepTwo.querySelector('.mobile-note .custom-size-modal').style.display = 'none';
      }
      
    });
    dropdowns.forEach((dropdown) => {
      if (dropdown.type == 'production') return;
      const id = dropdown.type.toLowerCase();
      const value = dropdown.args.selected_value;
      if (dropdown.type == 'size') {
        const tempOptions = dropdown.args.values.map((tempOption) => {
          return {
            value: tempOption.value,
          };
        });
        const data = {
          id,
          show_unit_price: false,
          options: tempOptions,
          selected_value: value,
          label: 'Size',
          type: 'size',
          tag: 'size-dropdown',
        };
        const size = this.creationSelect(data);
        string.insertAdjacentHTML('beforeend', size);
      } else if (dropdown.type == 'qty') {
        console.log(dropdown)
        const tempOptions = dropdown.args.values.map((tempOption) => {
          return {
            value: tempOption.value,
          };
        });
        const data = {
          id,
          show_unit_price: false,
          options: tempOptions,
          selected_value: value,
          label: 'Quantity',
          type: 'quantity',
          tag: 'quantity-dropdown',
          editable: dropdown.args.custom,
        };
        const size = this.creationSelect(data);
        string.insertAdjacentHTML('beforeend', size);
      } else {
        let text = this.titlesDropdown[dropdown.type];
        const type = dropdown.type;
        text = this.titlesDropdown[dropdown.type] || dropdown.type;
        const firstLetter = text ? text.charAt(0) : '';
        const rest = text.slice(1);
        const label = firstLetter.toUpperCase() + rest;

        const tempOptions = dropdown.args.values.map((tempOption) => {
          return {
            value: tempOption.value,
          };
        });

        const data = {
          id,
          show_unit_price: false,
          options: tempOptions,
          selected_value: value,
          label,
          type,
          tag: 'custom-dropdown',
        };

        const printing = this.creationSelect(data);
        string.insertAdjacentHTML('beforeend', printing);
      }
    });

    if (json.hasOwnProperty('materials') && json.materials != null && this.dataset.type != 'extension-product') {
      this.stepTwo.querySelector('.note-column .custom-size-modal').style.display = 'block';
      this.stepTwo.querySelector('.mobile-note .custom-size-modal').style.display = 'block';
    }

    this.stepTwo.querySelector('.product-preview-component .title').textContent = title;
    this.stepTwo.querySelector('.product-preview-component .description').innerHTML = description;
    this.stepTwo.querySelector('.product-preview-component .price').innerHTML = price;
    this.stepTwo.querySelector('.product-preview-component').href = url;
    this.stepTwo.querySelector('.image-container').style = style;
    this.stepTwo.querySelector('.image-container').style.cssText = style.cssText;
    this.stepTwo.querySelector('textarea').value = '';

    string.dataset.section = this.dataset.section;
    string.dataset.blankType = json.blanktype;
    string.dataset.boxtype = json.boxtype;
    string.dataset.url = url;
    string.dataset.id = json.id;
    string.dataset.userid = this.dataset.userid;
    string.dataset.handle = json.handle;

    // scriptTemp
    const scriptScriptTemp = document.createElement('script');
    scriptScriptTemp.type = 'application/json';
    scriptScriptTemp.textContent = scriptTemp;
    string.appendChild(scriptScriptTemp);

    // jsonProduct
    const scriptJsonProduct = document.createElement('script');
    scriptJsonProduct.id = 'product-json';
    scriptJsonProduct.classList.add('product-json');
    scriptJsonProduct.type = 'application/json';
    scriptJsonProduct.textContent = jsonProduct;
    string.appendChild(scriptJsonProduct);
    // JsonVariants
    const scriptJsonVariants = document.createElement('script');
    scriptJsonVariants.id = 'variants-json';
    scriptJsonVariants.classList.add('variants-json');
    scriptJsonVariants.type = 'application/json';
    scriptJsonVariants.textContent = jsonVariants;
    string.appendChild(scriptJsonVariants);

    const productParse = JSON.parse(jsonProduct);
    let is_case_quantity = false;
    if (productParse.tags.includes('case-quantity')) {
      is_case_quantity = true;
    }

    if (is_case_quantity) {
      const modalCaseQuantity = document.createElement('modal-case-quantity');
      string.appendChild(modalCaseQuantity);

      const quantityType = document.createElement('quantity-type');
      quantityType.classList.add('quantity-type');
      quantityType.style.display = 'none';
      quantityType.innerHTML = `
        <h6 class="pre">Quantity*</h6>
        <div class="container-buttons">
          <button class="buttonRadio unit" data-value="unit">25 Units</button>
          <button class="buttonRadio package" data-value="package">Case (<span class="unit-for-package">###</span>)</button>
        </div>
      `;
      string.appendChild(quantityType);

    }
    
    this.stepTwo.querySelector(
      '.dropdowns-column',
    ).innerHTML = `<variant-selects data-update="true" data-section="${this.dataset.section}" data-blankType="${json.blanktype}" data-boxType="${json.boxtype}" data-url="${url}" data-id="${json.id}" data-userid="${this.dataset.userid}" data-type="${json.type}" data-handle="${json.handle}">${string.innerHTML}<script type="application/json">${scriptTemp}</script>
      <script id="product-json" type="application/json">${jsonProduct}</script>
      <script id="variants-json" type="application/json">${jsonVariants}</script></variant-selects>`;

    this.hideAllStep();

    this.stepTwo.style.display = 'block';

    if (json.boxtype == 'mailer' || json.boxtype == 'shipper') {
      this.modalContainer.boxType = json.boxtype;
    }

    const quantityDropdown = document.querySelector('quantity-dropdown');
    quantityDropdown.currentOption = quantityDropdown.options[0];
  }

  eventClickButtonsMove(evt) {
    this.hideAllStep();
    this.activeBorderLine = evt.target.dataset.active;
    this.querySelector('.custom-order-item.step-' + evt.target.dataset.step).style.display = 'block';
    this.setBorderLine();
  }

  eventClickButtonsProductListing(evt) {
    this.hideFirstStep();
    this.querySelector('.button-back').dataset.step = '1-' + evt.target.dataset.products;
    let index = parseInt(evt.target.dataset.slider);
    this.swiper[index].slideTo(0);

    if (this.textBlue.length > 0) {
      this.textBlue.forEach((textBlue) => {
        textBlue.innerHTML = '1-3';
      });
    }
    this.querySelector('.custom-order-item.step-1-' + evt.target.dataset.products).style.display = 'block';
    this.querySelector('.custom-order-item.step-1-' + evt.target.dataset.products).classList.add('active');
  }

  _handlelize(str) {
    str = str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
      .replace(/\-\-+/g, '-') // Replaces multiple hyphens by one hyphen
      .replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
      .toLowerCase(); // To lowercase

    return str;
  }
}

customElements.define('app-custom-order', AppCustomOrder);
